module.exports = __webpack_public_path__ + "static/nestle-8fd457791795a0f2bad33eaaed033c20.svg";